const periodsRange = (periods) => {
  if (!periods || periods.length === 0) {
    return {
      start: null,
      end: null,
    }
  } else {
    const deltas = periods.map((period) => period.delta)

    return {
      start: Math.min(...deltas),
      end: Math.max(...deltas),
    }
  }
}

export default periodsRange
